import React, { useCallback, useState } from 'react';

import AlertBar from '../components/AlertBar';
import NavBar from '../components/NavBar';
import Hero from '../components/hero/Hero';
import EnquiryModal from '../components/hero/EnquiryModal';
import MatchQuiz from '../components/hero/MatchQuiz';
import CategoryGrid from '../components/CategoryGrid';
import AboutSection from '../components/AboutSection';
import WikiSection from '../components/WikiSection';
import FaqSection from '../components/FaqSection';
import Footer from '../components/footer/Footer';

import { FALLBACK_CATEGORIES, FALLBACK_FAQS } from '../api/fallback';

export default function LandingPage() {
  // /api/stats is no longer fetched: the hero showed the only figures it
  // carried, and none of them were supportable pre-launch. The endpoint and
  // getStats() stay available for when there is real supply to report.

  // Conditions and FAQs are rendered from the bundle, not fetched. They are
  // module-level constants in backend/data.py — the API computes nothing and
  // reads no table, so the request returned exactly what the bundle already
  // held. On a free instance that sleeps after 15 minutes, the round trip cost
  // a ~50s cold start during which both sections sat as loading skeletons on a
  // page whose content was already in the browser. /api/categories and
  // /api/faqs still exist for other clients; ApplyPage reads these same
  // constants directly.
  const categories = FALLBACK_CATEGORIES;
  const faqs = FALLBACK_FAQS;

  // Searching opens the enquiry form rather than a results page. There is no
  // roster to search yet, so results would be theatre; handing the query to a
  // human who answers it is the one honest thing the button can do. When there
  // is supply, this is the seam where navigation to /search goes instead.
  const [enquiry, setEnquiry] = useState(null);
  const [quizOpen, setQuizOpen] = useState(false);

  const handleSearch = useCallback((query) => setEnquiry(query), []);

  const closeEnquiry = useCallback(() => setEnquiry(null), []);

  // The quiz ends in the same shape the search bar produces, so finishing it
  // is just a search someone answered questions to build. Closing the quiz
  // first keeps one dialog on screen at a time.
  const handleQuizFinish = useCallback((result) => {
    setQuizOpen(false);
    setEnquiry(result);
  }, []);


  return (
    <>
      <AlertBar />
      <NavBar />

      <main>
        <Hero
          categories={categories}
          onSearch={handleSearch}
          onStartQuiz={() => setQuizOpen(true)}
        />

        <CategoryGrid categories={categories} />

        <AboutSection />

        <WikiSection />

        <FaqSection faqs={faqs} />
      </main>

      <Footer />

      <MatchQuiz
        show={quizOpen}
        onHide={() => setQuizOpen(false)}
        onFinish={handleQuizFinish}
      />

      <EnquiryModal show={Boolean(enquiry)} query={enquiry} onHide={closeEnquiry} />
    </>
  );
}
